import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { img } from "../../lib/api";
import { useLang } from "../../context/LangContext";
import { useCart } from "../../context/CartContext";
import { Price } from "./Price";

export const ProductCard = ({ p, tall = false }) => {
  const { t, L } = useLang();
  const { wishlist, toggleWish } = useCart();
  const liked = wishlist.includes(p.id);
  const soldOut = p.status === "unavailable" || p.total_stock === 0;

  const onWish = (e) => {
    e.preventDefault();
    toast(toggleWish(p.id) ? t("added_wish") : t("removed_wish"));
  };

  return (
    <Link to={`/product/${p.slug}`} data-testid={`product-card-${p.slug}`} className="group block">
      <div className={`relative overflow-hidden bg-sand-light ${tall ? "aspect-[3/4.4]" : "aspect-[3/4]"}`}>
        <img src={img(p.images?.[0])} alt={L(p, "name")} loading="lazy" className="img-zoom h-full w-full object-cover" />
        {p.images?.[1] && (
          <img src={img(p.images[1])} alt="" loading="lazy"
            className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
        )}
        <div className="absolute start-3 top-3 flex flex-col gap-1.5">
          {p.final_price < p.price && <span className="bg-ink px-2.5 py-1 text-[10px] tracking-[0.2em] text-ivory">{t("sale")}</span>}
          {p.is_new && <span className="bg-ivory/90 px-2.5 py-1 text-[10px] tracking-[0.2em]">{t("new_badge")}</span>}
          {soldOut && <span className="bg-sand px-2.5 py-1 text-[10px] tracking-[0.2em]">{t("out_of_stock")}</span>}
        </div>
        <button onClick={onWish} data-testid={`wishlist-toggle-${p.slug}`} aria-label="wishlist"
          className="absolute end-3 top-3 grid h-9 w-9 place-items-center rounded-full bg-ivory/80 backdrop-blur transition-transform duration-300 hover:scale-110">
          <Heart size={16} strokeWidth={1.4} className={liked ? "fill-ink" : ""} />
        </button>
        <span className="absolute inset-x-3 bottom-3 translate-y-3 bg-ivory/90 py-3 text-center text-[12px] tracking-[0.18em] opacity-0 backdrop-blur transition-[opacity,transform] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
          {t("explore")}
        </span>
      </div>
      <div className="mt-4 flex items-start justify-between gap-3">
        <h3 className="font-body text-[15px] leading-snug">{L(p, "name")}</h3>
        <Price price={p.price} final={p.final_price} className="shrink-0 text-[14px]" />
      </div>
    </Link>
  );
};
